import { Link } from 'react-router-dom';

const newsList = [
  {
    id: 'news-1',
    title: '惠美梨2026年翠冠梨新鲜上市，首批预售火爆开启',
    excerpt: '盛夏七月，惠美梨翠冠梨迎来丰收季。得益于今年充沛的雨水和充足的日照，本季翠冠梨品质再创新高，单果均重突破300g，含糖量达14%以上。',
    date: '2026-07-15',
    category: '产品动态',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20green%20pears%20in%20a%20wooden%20basket%20on%20a%20rustic%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20warm%20cozy%20farmhouse%20atmosphere%2C%20editorial%20food%20photography%2C%20earthy%20green%20tones%2C%20organic%20composition%2C%20shallow%20depth%20of%20field&width=600&height=400&seq=news-cuiguan-2026&orientation=landscape',
  },
  {
    id: 'news-2',
    title: '惠美梨荣获2026年中国优质农产品金奖',
    excerpt: '在刚刚落幕的2026年中国优质农产品博览会上，惠美梨黄花梨品种凭借卓越品质脱颖而出，荣获金奖殊荣，这是对惠美梨坚持品质路线的最好肯定。',
    date: '2026-06-28',
    category: '品牌荣誉',
    image: 'https://readdy.ai/api/search-image?query=A%20golden%20trophy%20and%20certificate%20placed%20next%20to%20beautiful%20golden%20pears%20on%20a%20elegant%20marble%20surface%2C%20soft%20natural%20lighting%2C%20prestigious%20award%20ceremony%20aesthetic%2C%20warm%20golden%20tones%2C%20editorial%20photography%2C%20clean%20luxurious%20composition&width=600&height=400&seq=news-award-2026&orientation=landscape',
  },
  {
    id: 'news-3',
    title: '惠美梨智能果园升级完成，科技赋能品质再提升',
    excerpt: '惠美梨投资建设的智慧农业系统全面升级完成，引入AI图像识别分选、无人机巡检、物联网环境监测等先进技术，实现从种植到分选的全链路智能化管理。',
    date: '2026-05-20',
    category: '企业动态',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20orchard%20with%20drone%20flying%20over%20pear%20trees%2C%20digital%20technology%20in%20agriculture%2C%20warm%20sunset%20light%2C%20innovative%20farming%20aesthetic%2C%20professional%20photography%2C%20natural%20green%20and%20golden%20tones%2C%20clean%20composition&width=600&height=400&seq=news-tech-2026&orientation=landscape',
  },
];

export default function NewsSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 md:mb-16 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              梨果资讯
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              最新动态
            </h2>
          </div>
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {newsList.map((news) => (
            <Link
              key={news.id}
              to={`/articles/${news.id}`}
              className="group rounded-2xl bg-background-50 overflow-hidden cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={news.image}
                  alt={news.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                    {news.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="text-xs text-foreground-400 mb-3">{news.date}</div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {news.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {news.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}